import { render, staticRenderFns } from "./supplementInfo.vue?vue&type=template&id=3cdebfe2&scoped=true&"
import script from "./supplementInfo.vue?vue&type=script&lang=js&"
export * from "./supplementInfo.vue?vue&type=script&lang=js&"
import style0 from "./supplementInfo.vue?vue&type=style&index=0&id=3cdebfe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdebfe2",
  null
  
)

export default component.exports